export default __webpack_public_path__ + "static/media/Curvet6.7.92a4444d.svg";